import { DeviceType } from 'shared/models';

//
// Calculate the minimum height of position indicator text given a device type
// where the PI text will be displayed. The result is given in the range (0, 1)
// where 0 means no height and 1 is the full height of the theme.
//
export const calcMinPITextHeight = (deviceType: DeviceType | null, rotated: boolean, isNorthAmerica?: boolean, isFloorText?: boolean): number => {
    if (!deviceType) return 0;

    // 3/8" worldwide for MaxPersons, MaxWeight, and ElevatorID PI types
    // 5/8" (16mm) minimum covers the bases across North America where the Floor PI will be installed
    // 1.57" minimum covers the rest of the world where the Floor PI will be installed
    const minHeightInInches = isFloorText ? (isNorthAmerica ? 0.629921 : 1.57) : 0.375;

    const { physicalWidth, physicalHeight } = deviceType;
    if (!physicalHeight || !physicalWidth) {
        return 0;
    }
    return (
        rotated
            ? minHeightInInches / physicalWidth
            : minHeightInInches / physicalHeight
    );
};
